<template>
  <div>
    <!-- <div v-if="noSector && !isLoading" class="instructions">No Sector Decteded.</div> -->
    <div v-if="(rsvpInMap.id === null && tabActive.rsvp !== 'runs') || (tabActive.rsvp === 'runs' && runsStore.other.runsInMap.length !== 1)" class="instructions">
      Click on the pin map icon on the reservations table to search for drivers with availability.
      <div v-if="tabActive.rsvp === 'runs'" class="message">Please select only one <b>RUN</b> to enable Driver Availability function.</div>
    </div>
    <div class="availability-loader" v-if="(rsvpInMap.id !== null || runsStore.other.runsInMap.length === 1) && isLoading">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <div class="message">Searching for drivers with availability...</div>
    </div>
    <div v-if="((rsvpInMap.id !== null && tabActive.rsvp !== 'runs') || (tabActive.rsvp === 'runs' && runsStore.other.runsInMap.length === 1)) && !isLoading">
      <div class="sector-name">{{ sectorName }}</div>
      <div class="drivers work">
        <div class="title">
          <span>DRIVERS WITH AVAILABILITY</span>
          <span class="driver-count">TOTAL: {{ drivers.work.length }}</span>
        </div>
        <table v-if="drivers.work.length > 0">
          <thead>
            <tr class="table-header">
              <th></th>
              <th>ID</th>
              <th>NAME</th>
              <th>SECTOR</th>
              <th>SHIFT START</th>
              <th>SHIFT END</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr class="driver" v-for="driver in drivers.work">
              <td><input type="radio" name="seletedDriver" :value="driver.driverId" v-model="selectedDriver" /></td>
              <td class="id"><a :href="'/#/provider/' + driver.driverId" target="_blank">{{ driver.driverId }}</a></td>
              <td>{{ driver.firstName }} {{ driver.lastName }}</td>
              <td>{{ sectorName }}</td>
              <td v-bind:class="[ 'driver-shift', driver.shiftState ]">{{ formatShiftTimes(driver.shiftStart) }}</td>
              <td v-bind:class="[ 'driver-shift', driver.shiftState ]">{{ formatShiftTimes(driver.shiftEnd) }}</td>
              <td>Available</td>
            </tr>
          </tbody>
        </table>
        <div v-else class="no-drivers">Sorry but we can't find drivers with availability for sector {{ sectorName }}.</div>
      </div>

      <div class="drivers home">
        <div class="title">
          <span>HOME-BASED DRIVERS</span>
          <span class="driver-count">TOTAL: {{ drivers.home.length }}</span>
        </div>
        <table v-if="drivers.home.length > 0">
          <thead>
            <tr class="table-header">
              <th></th>
              <th>ID</th>
              <th>NAME</th>
              <th>SECTOR</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr class="driver" v-for="driver in drivers.home">
              <td><input type="radio" name="seletedDriver" :value="driver.driverId" v-model="selectedDriver" /></td>
              <td class="id"><a :href="'/#/provider/' + driver.driverId" target="_blank">{{ driver.driverId }}</a></td>
              <td>{{ driver.firstName }} {{ driver.lastName }}</td>
              <td>{{ sectorName }}</td>
              <td>
                <span>{{ driver.rsvp === null ? 'Available' : 'Ongoing' }}</span>
                <span v-if="driver.rsvp !== null">
                  (<a :href="'/#/reservation/' + driver.rsvp.rsvpId" target="_blank">{{ driver.rsvp.rsvpId }}</a>)
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="no-drivers">Sorry but we can't find drivers that are home-based in sector {{ sectorName }}.</div>
      </div>

      <div class="drivers home unavailable">
        <div class="title">
          <span>DRIVERS WITHOUT AVAILABILITY</span>
          <span class="driver-count">TOTAL: {{ unavailableDrivers.list.length }}</span>
        </div>
        <table v-if="unavailableDrivers.list.length > 0">
          <thead>
            <tr class="table-header">
              <!-- <th></th> -->
              <th>ID</th>
              <th>NAME</th>
              <th>PHONE</th>
            </tr>
          </thead>
          <tbody>
            <tr class="driver" v-for="driver in unavailableDrivers.list">
              <!-- <td><input type="radio" name="seletedDriver" :value="driver.driverId" v-model="selectedDriver" /></td> -->
              <td class="id"><a :href="'/#/provider/' + driver.id" target="_blank">{{ driver.id }}</a></td>
              <td>{{ driver.firstName }} {{ driver.lastName }}</td>
              <td>{{ driver.mobile }}</td>
              <!-- <td>
                <span>{{ driver.rsvp === null ? 'Available' : 'Ongoing' }}</span>
                <span v-if="driver.rsvp !== null">
                  (<a :href="'/#/reservation/' + driver.rsvp.rsvpId" target="_blank">{{ driver.rsvp.rsvpId }}</a>)
                </span>
              </td> -->
            </tr>
          </tbody>
        </table>
        <div v-else class="no-drivers">Sorry but we can't find drivers that are unavailable right now.</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'driver-availability',
  data () {
    return {
      isLoading: false,
      isError: false,
      sectorName: '',
      drivers: {
        home: [],
        work: []
      }
    }
  },
  computed: {
    dispatch () { return this.$store.state.dispatch },
    rsvpInMap () { return this.dispatch.rsvpInMap },
    selectedDriver: {
      get () { return this.dispatch.selectedDriver },
      set (value) { this.$store.commit('dispatch/setSelectedDriver', value) }
    },
    tabActive () { return this.dispatch.tabActive },
    runsStore () { return this.$store.state.runs },
    _runsCheckId () { return this.runsStore.driverAvailability.checkId },
    runsInMap () { return this.runsStore.other.runsInMap },
    noSector () { return this.dispatch.noSector },
    unavailableDrivers () { return this.dispatch.unavailableDrivers }
  },
  methods: {
    getRsvpInfo () {
      let self = this
      self.isLoading = true
      self.isError = false
      let rsvp = self.rsvpInMap
      let url = '/admin/rsvp/' + rsvp.id
      if (rsvp.isPackage) {
        url = '/admin/package/' + rsvp.id
      }
      self.$sdk.get(url, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.isLoading = false
        if (r.error) {
          self.isError = true
          return
        }

        if (!r.pickupSector) {
          self.$store.commit('dispatch/setNoSector', true)
          return
        }
        self.$store.commit('dispatch/setNoSector', false)

        let pickupTime = moment(rsvp.pickupTime, 'MM/DD/YYYY hh:mmA')
        self.sectorName = r.pickupSector.name
        let pickupTimePlusETA = pickupTime.add(r.etaInSec, 'seconds')
        self.getCoverageInfo(r.pickupSector.ID, self.rsvpInMap.serviceId, pickupTime, pickupTimePlusETA)
        // self.getCoverageInfo(r.pickupSector.ID, pickupTime)
      })
    },
    formatShiftTimes (times) {
      return moment(times, 'X').format('MM/DD hh:mmA')
    },
    getCoverageInfo (sectorId, serviceTypeId, pickupTime, pickupTimePlusETA) {
      let self = this
      self.isLoading = true
      self.isError = false
      self.drivers = {
        home: [],
        work: []
      }
      self.$sdk.get('/sectors/' + sectorId + '/coverage', {
        token: self.$store.state.session.sessionToken,
        start: pickupTime.format('YYYY-MM-DD'),
        end: pickupTime.format('YYYY-MM-DD')
      }, r => {
        self.isLoading = false
        if (r.error) {
          self.isError = true
          return
        }

        self.getUnavailableDrivers(r, serviceTypeId, pickupTime, pickupTimePlusETA)
        // self.getDrivers(r)
      })
    },
    getShiftState (driver) {
      let self = this
      let rsvp = self.rsvpInMap
      let rsvpStart = moment(rsvp.pickupTime, 'MM/DD/YYYY hh:mmA').format('X')
      let rsvpEnd = moment(rsvp.pickupTime, 'MM/DD/YYYY hh:mmA').add(rsvp.etaInSec, 'seconds').format('X')
      let shiftStart = driver.shiftStart
      let shiftEnd = driver.shiftEnd

      // completely encompass trip
      if (rsvpStart >= shiftStart && rsvpStart <= shiftEnd &&
          rsvpEnd >= shiftStart && rsvpEnd <= shiftEnd) {
        return 'success'
      }

      // partially encompass trip
      if ((shiftStart >= rsvpStart && shiftStart <= rsvpEnd) ||
            (shiftEnd >= rsvpStart && shiftEnd <= rsvpEnd)) {
        return 'warning'
      }

      // outside the shift
      return 'error'
    },
    getDrivers (sector) {
      let self = this
      let ids = []
      for (let i = 0; i < sector.driverWork.length; i++) {
        ids.push(sector.driverWork[i].driverId)
      }
      for (let i = 0; i < sector.driverHome.length; i++) {
        let id = sector.driverHome[i].driverId
        if (ids.indexOf(id) >= 0) {
          continue
        }
        ids.push(id)
      }
      self.isLoading = true
      self.$sdk.get('/provider', {
        token: self.$store.state.session.sessionToken,
        ids: ids
      }, r => {
        self.isLoading = false
        if (r.error) {
          return
        }

        for (let i = 0; i < sector.driverWork.length; i++) {
          let driver = sector.driverWork[i]
          if (!self.doesDriverHaveValidServiceType(driver)) {
            continue
          }
          let info = self.getDriver(driver.driverId, r.list)
          driver['rsvp'] = info === null ? null : info.rsvp
          driver['shiftState'] = self.getShiftState(driver)
          self.drivers.work.push(driver)
        }

        if (self.drivers.work.length > 0) {
          let compare = (a, b) => {
            if (a.shiftState === 'success') {
              return -1
            }
            if (b.shiftState === 'success') {
              return 1
            }
            if (a.shiftState === 'warning' && b.shiftState === 'error') {
              return  -1
            }
            if (a.shiftState === 'error' && b.shiftState === 'warning') {
              return 1
            }
            return 0
          }
          self.drivers.work.sort(compare)
        }

        for (let i = 0; i < sector.driverHome.length; i++) {
          let driver = sector.driverHome[i]
          if (self.doesDriverHaveShift(driver.driverId)) {
            continue
          }
          if (!self.doesDriverHaveValidServiceType(driver)) {
            continue
          }
          let info = self.getDriver(driver.driverId, r.list)
          driver['rsvp'] = info === null ? null : info.rsvp
          self.drivers.home.push(driver)
        }
      })
    },
    doesDriverHaveValidServiceType (driver) {
      let self = this
      if (self.dispatch.tabActive.rsvp === 'runs') {
        return driver.services.indexOf(self.runsStore.driverAvailability.rsvpData.service.id) >= 0
      }
      return driver.services && driver.services.indexOf(self.rsvpInMap.serviceId) >= 0
    },
    doesDriverHaveShift (driverId) {
      let self = this
      for (let i = 0; i < self.drivers.work.length; i++) {
        let driver = self.drivers.work[i]
        if (driver.driverId === driverId) {
          return true
        }
      }
      return false
    },
    getDriver (id, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].ID === id) {
          return list[i]
        }
      }
      return null
    },
    checkAvailability () {
      if (this.rsvpInMap.id) {
        this.getRsvpInfo()
      }
    },
    checkRunAvailability (id) {
      let self = this
      let driverAvailability = self.runsStore.driverAvailability
      // if (driverAvailability.lastCheckId === driverAvailability.checkId) return

      self.isLoading = true
      self.isError = false
      self.$sdk.get(`/admin/rsvp/${id}`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.isLoading = false
        if (r.error) {
          self.isError = true
          return
        }
        if (!r.pickupSector) {
          self.$store.commit('dispatch/setNoSector', true)
          return
        }
        self.$store.commit('dispatch/setNoSector', false)

        let pickupTime = moment(driverAvailability.rsvpData.pickupDate, 'MM/DD/YYYY hh:mmA')
        self.sectorName = r.pickupSector.name
        let pickupTimePlusETA = pickupTime.add(r.etaInSec, 'seconds')
        self.getCoverageInfo(r.pickupSector.ID, driverAvailability.rsvpData.service.id, pickupTime, pickupTimePlusETA)
      })
    },
    getUnavailableDrivers (data, serviceTypeId, pickupTime, pickupTimePlusETA) {
      let self = this
      self.$store.commit('dispatch/setAvailableDriversData', {loading: true})
      self.$sdk.get('/shifts/unavailable', {
        token: self.$store.state.session.sessionToken,
        serviceTypeId: serviceTypeId,
        since: pickupTime.format('X'),
        until: pickupTimePlusETA.format('X')
      }, r => {
        let list = []
        if (!r.error) {
          r.list.forEach(driver => {
            list.push({
              id: driver.ID,
              firstName: driver.firstName,
              lastName: driver.lastName,
              mobile: driver.displayPhone
              // mobile: driver.phone.number,
              // countryCode: driver.phone.countryCode
            })
          })
        }
        self.$store.commit('dispatch/setUnavailableDriversData', {
          loading: false,
          list: list
        })
        self.getDrivers(data)
      })
    }
  },
  watch: {
    rsvpInMap (value) {
      if (value.id === null) {
        return
      }
      // let self = this
      // self.getRsvpInfo()
    },
    runsInMap (x) {
      if (x) {
        if (x.length !== 1) {
          this.drivers = {
            home: [],
            work: []
          }
          this.$store.commit('runs/setDriverAvailabilityData', {
            lastCheckId: '',
            checkId: ''
          })
          return
        } else {
          let i = this.runsStore.list.findIndex(n => n.id === x[0])
          if (i > -1) {
            this.$store.commit('runs/setDriverAvailabilityData', {
              checkId: this.runsStore.list[i].rsvpIDs[0],
              rsvpData: this.runsStore.list[i].rsvps.find(n => n.id === this.runsStore.list[i].rsvpIDs[0])
            })
          }
        }
      }
    },
    _runsCheckId (x) {
      if (x) {
        this.checkRunAvailability(x)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sector-name {
  font-size: 18px;
  margin-bottom: 15px;
}
.no-drivers {
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #555;
}
.instructions, .availability-loader {
  text-align: center;
  padding: 30px 0;
  font-weight: 600;
  color: #555;

  & .message { margin-top: 10px; }
}
.drivers {
  margin-bottom: 30px;
  & .title {
    font-size: 12px;
    font-weight: 700;
    color: #777;
    margin-bottom: 10px;
    position: relative;

    & > span {
      display: inline-block;
      vertical-align: middle;

    }

    & > .driver-count {
      position: absolute;
      right: 0;
    }
  }
}
table{
  border-collapse: collapse;
  width: 100%;
}

.table-header{
  color: #8DA0A9;
  font-size: 12px;
  border: 1px solid rgba(0,0,0,0.3);
  background-color: #f5f5f5;

  & th{
    padding: 5px 10px;
    &.sortable {
      cursor: pointer;
      text-decoration: underline;
      color: #333;
      transition: all 250ms;

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }
  }
}

.driver{
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.3);
  position: relative;

  &.new {
    border-left: 5px solid #F25E0D;
  }

  & td{
    padding: 10px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 5px;

    &.map-button{
      padding: 10px 0;

      & a{
        color: #fff;
        background-color: #aaa;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        display: inline-block;
        border-radius: 30px;
        transition: all 250ms;

        & i {line-height: inherit;}

        &.disabled{
          pointer-events: none;
          opacity: 0.5;
          background-color: #bbb;
        }
        &.selected{
          background-color: #26D97A;
        }
      }
    }

    & input{
      margin-top: 0;
      width: 13px;
    }
  }

  & a{ font-weight: 700; }

  & .driver-shift {
    font-weight: 600;
    &.success { color: #26D97A; }
    &.warning { color: #F25E0D; }
    &.error { color: #F20D0D; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/DriverAvailability.vue